@if(entry === 'participantEnrollment' && associationDetailsData) {
<form nz-form [formGroup]="newContactForm" class="ppl-p0">

    @if(isAttrAvailable('newAuthRep')){
    <ppl-accordion [title]="'Authorized Representative'" [isOpen]="true"
        *authorize="[pageId, tabId, 'DesignatedRepresentative', 'section']">
        <ppl-association-details [sectionName]="'authorized_representative'" [gridData]="getProviderData('AR')"
            [tabId]="tabId" [pageId]="pageId" [sectionId]="'DesignatedRepresentative'" [consumerData]="consumerData"
            [gridCols]="getProviderColumns('AR')" [readonly]="readonly"
            [allowMultiple]="allowMultiple['AR']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newEmployer') && !isRecieveGoodsAndServicesOnly){
    <ppl-accordion [title]="'Employer of Record'" [isOpen]="true"
        *authorize="[pageId, tabId, 'EmployerDetails', 'section']">
        <ppl-association-details [sectionName]="'employer'" [gridData]="getProviderData('EMP')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'EmployerDetails'" [gridCols]="getProviderColumns('EMP')"
            [readonly]="readonly" [allowMultiple]="allowMultiple['EMP']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newProvider') && !isRecieveGoodsAndServicesOnly){
    <ppl-accordion [title]="'Independent Providers'" [isOpen]="true"
        *authorize="[pageId, tabId, 'PersonalAssistant', 'section']">
        <ppl-association-details [sectionName]="'independent_provider'" [gridData]="getProviderData('IR')"
            [tabId]="tabId" [pageId]="pageId" [sectionId]="'PersonalAssistant'" [gridCols]="getProviderColumns('IR')"
            [readonly]="readonly" [allowMultiple]="allowMultiple['IR']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newContractor')){
    <ppl-accordion [title]="'Independent Contractors'" [isOpen]="true"
        *authorize="[pageId, tabId, 'IndependentContractor', 'section']">
        <ppl-association-details [sectionName]="'independent_contractor'" [gridData]="getProviderData('IC')"
            [tabId]="tabId" [pageId]="pageId" [sectionId]="'IndependentContractor'"
            [gridCols]="getProviderColumns('IC')" [readonly]="readonly"
            [allowMultiple]="allowMultiple['IC']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newVendor')){
    <ppl-accordion [title]="'Vendors'" [isOpen]="true" *authorize="[pageId, tabId, 'Vendor', 'section']">
        <ppl-association-details [sectionName]="'vendor'" [gridData]="getProviderData('VE')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'Vendor'" [gridCols]="getProviderColumns('vendor')" [readonly]="readonly"
            [allowMultiple]="allowMultiple['VE']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newIndependentFacilitator')){
    <ppl-accordion [title]="'Independent Facilitators'" [isOpen]="true"
        *authorize="[pageId, tabId, 'IndependentFacilitator', 'section']">
        <ppl-association-details [sectionName]="'independent_facilitator'" [gridData]="getProviderData('IF')"
            [tabId]="tabId" [pageId]="pageId" [sectionId]="'IndependentFacilitator'"
            [gridCols]="getProviderColumns('IF')" [readonly]="readonly"
            [allowMultiple]="allowMultiple['IF']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newPOA')){
    <ppl-accordion [title]="'POA'" [isOpen]="true" *authorize="[pageId, tabId, 'POA', 'section']">
        @if(isParticipantMinor){
        <nz-alert nzType="info" nzMessage="Participant is a minor. Adding a POA is not allowed." nzShowIcon></nz-alert>
        }
        <ppl-association-details [sectionName]="'poa'" [gridData]="getProviderData('POA')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'POA'" [gridCols]="getProviderColumns('POA')" [readonly]="readonly"
            [allowMultiple]="allowMultiple['POA']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newConservator')){
    <ppl-accordion [title]="'Conservator'" [isOpen]="true" *authorize="[pageId, tabId, 'Conservator', 'section']">
        @if(isParticipantMinor){
        <nz-alert nzType="info" nzMessage="Participant is a minor. Adding a Conservator is not allowed." nzShowIcon></nz-alert>
        }
        <ppl-association-details [sectionName]="'conservator'" [gridData]="getProviderData('CNV')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'Conservator'" [gridCols]="getProviderColumns('CNV')" [readonly]="readonly"
            [allowMultiple]="allowMultiple['CNV']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

    @if(isAttrAvailable('newLegalGuardian')){
    <ppl-accordion [title]="'Legal Guardian'" [isOpen]="true" *authorize="[pageId, tabId, 'LegalGuardian', 'section']">
        <ppl-association-details [sectionName]="'legal_guardian'" [gridData]="getProviderData('LG')" [tabId]="tabId"
            [pageId]="pageId" [sectionId]="'LegalGuardian'" [gridCols]="getProviderColumns('LG')" [readonly]="readonly"
            [allowMultiple]="allowMultiple['LG']" [allAssociations]="associationDetailsData"></ppl-association-details>
    </ppl-accordion>
    }

</form>
}
@else{
<ppl-accordion [title]="'Associations'" [isOpen]="true" *authorize="[pageId, tabId, 'Associations', 'section']">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isAssociationsEditable || canManageConsumer || canShowStatus || canDeleteAssociation"
        [data]="prvdrAssociations" [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)">
    </ppl-list-table>
</ppl-accordion>

<div class="filter-panel">
    <ng-template #inactivateConfirmationDialog let-cancel="cancel">
        <p>This association will be deleted. Do you want to continue?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <!-- <ppl-modal [showModal]="showModal" [title]="modalBody" [isOkText]="'Save'" (confirm)="handleCancel()"
            (cancel)="handleCancel()"> -->
    <ng-template #manageStatusDialog let-cancel="cancel">
        @if (mode === 'read' && !disableAddStatus) {
        <div pplFocusTrap class="custom-row">
            <div class="mr-2">
                <ppl-button #addStatusBtn label="Add Status" icon="fa fa-plus" [customClass]="'ghost-button dialog-btn'"
                    [iconPosition]="'left'" (click)="addStatus()"></ppl-button>
            </div>
        </div>
        }

        @if (mode === 'read' && showMoveToInPPLReviewButton) {
        <div class="custom-row">
            <div class="mr-2">
                <ppl-button label="Move to PPL Review" icon="fa fa-arrow-circle-right"
                    [customClass]="'ghost-button dialog-btn'" [iconPosition]="'left'" (click)="moveToPPLReview()"
                    *authorize="[pageId, tabId, 'MoveToInPPLReview', 'section', 'edit']"></ppl-button>
            </div>
        </div>
        }

        @if(mode === 'edit' || mode === 'add') {
        <div pplFocusTrap>
            <div class="custom-row">
                <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                    (click)="cancelEdit()"></ppl-button>
                <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
                    (click)="save()" *authorize="[pageId, tabId, 'Associations', 'section', 'edit']"></ppl-button>
            </div>

            <div class="ppl-mt20">
                <form nz-form nz-row [formGroup]="enrollmentStatus" class="ppl-p0">
                    @if(isAttrAvailable('status')){
                    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                        <nz-row>
                            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="status" class="ppl-form-label">{{
                                getAttributes("status").label }}
                                @if(getAttributes('status').mandatory === 'Y'){
                                <span>*</span>
                                }</nz-form-label>
                            <nz-form-control class="ppl-form-control" nz-tooltip
                                nzTooltipTitle="{{getAttributes('status').tooltip}}" nzTooltipPlacement="topRight">
                                <div class="ppl-select" [ngClass]="{'error': validationErrors['status'] }">
                                    <ppl-dropdown-select formControlName="status" id="status"
                                        placeholder="Select Registration Status"
                                        [disabled]="mode === 'edit' || disableStatus" [options]="allowedStatus"
                                        [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                                    </ppl-dropdown-select>
                                </div>
                                @if (validationErrors['status']) {
                                    <span class="pl-1 error-message">{{validationErrors['status']}}</span>
                                }                                
                            </nz-form-control>
                        </nz-row>
                    </nz-form-item>
                    }

                    <div nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left"></div>


                    @if(isAttrAvailable('startDate') && !disableStatus){
                    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

                        <nz-row>
                            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="startDate"
                                class="ppl-form-label">{{getAttributes('startDate').label}}
                                @if(getAttributes('startDate').mandatory === 'Y' || isDisassociatedStatus(enrollmentStatus.get('status')?.value)){
                                <span>*</span>
                                }</nz-form-label>
                            <nz-form-control class="ppl-form-control">
                                <div nz-tooltip [nzTooltipTitle]="getAttributes('startDate')?.tooltip || ''"
                                    nzTooltipPlacement="topRight">
                                    <!-- <nz-date-picker formControlName="startDate" [id]="'startDate'" style="height: 32px;"
                                        [nzDisabledDate]="disabledStartDate" [nzFormat]="'MM/dd/yyyy'"
                                        [nzPlaceHolder]="getAttributes('startDate').placeholder"
                                        [ngClass]="{'error': validationErrors['startDate'] }"></nz-date-picker> -->
                                    <ppl-date-picker formControlName="startDate" [id]="'startDate'" [showIcon]="true"
                                        [placeholder]="getAttributes('startDate').placeholder" dateFormat="mm/dd/yy"
                                        [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                                        [panelStyleClass]="'custom-calendar-panel'" [minDate]="restoreMinStartDate" [maxDate]="minStartDate"
                                        [styleClass]="validationErrors['startDate'] ? 'error' : ''">
                                    </ppl-date-picker>
                                </div>
                                @if (validationErrors['startDate']) {
                                <span class="pl-1 error-message">{{validationErrors['startDate']}}</span>
                                }
                            </nz-form-control>
                        </nz-row>
                    </nz-form-item>
                    }

                    @if(isAttrAvailable('endDate') && !disableStatus){
                    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">

                        <nz-row>

                            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="endDate"
                                class="ppl-form-label">{{getAttributes('endDate').label}}
                                @if(getAttributes('endDate').mandatory === 'Y' || enrollmentStatus.get('status')?.value === 'DisEnroll'){
                                <span>*</span>
                                }</nz-form-label>
                            <nz-form-control class="ppl-form-control">
                                <div nz-tooltip [nzTooltipTitle]="getAttributes('endDate')?.tooltip || ''"
                                    nzTooltipPlacement="topRight">
                                    <ppl-date-picker formControlName="endDate" [id]="'endDate'" [showIcon]="true"
                                        [placeholder]="getAttributes('endDate').placeholder" dateFormat="mm/dd/yy"
                                        [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                                        [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate"
                                        [disabled]="isEmploymentDateStatus"
                                        [styleClass]="validationErrors['endDate'] ? 'error' : ''">
                                    </ppl-date-picker>
                                </div>
                                @if (validationErrors['endDate']) {
                                <span class="pl-1 error-message">{{validationErrors['endDate']}}</span>
                                }

                                @if((isDisassociatedStatus(enrollmentStatus.get('status')?.value) || enrollmentStatus.get('status')?.value === 'DisEnroll') && enrollmentStatus.get('endDate')?.touched && !enrollmentStatus.get('endDate')?.value){
                                    <span class="pl-1 error-message">Please select End Date.</span>
                                }
                            </nz-form-control>
                        </nz-row>
                    </nz-form-item>
                    }

                    @if(isAttrAvailable('reason')){
                    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                        <nz-row>
                            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="reason" class="ppl-form-label">{{
                                getAttributes("reason").label }}
                                @if(getAttributes('reason').mandatory === 'Y'){
                                <span>*</span>
                                }</nz-form-label>
                            <nz-form-control class="ppl-form-control" nz-tooltip
                                nzTooltipTitle="{{getAttributes('reason').tooltip}}" nzTooltipPlacement="topRight">
                                <div class="ppl-select" [ngClass]="{'error': validationErrors['reason'] }">
                                    <ppl-dropdown-select formControlName="reason" id="reason"
                                        placeholder="Select Reason" [disabled]="isEmploymentDateStatus"
                                        [options]="statusReasons"
                                        [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                                    </ppl-dropdown-select>
                                </div>
                                @if (validationErrors['reason']) {
                                <span class="pl-1 error-message">{{validationErrors['reason']}}</span>
                                }
                            </nz-form-control>
                        </nz-row>
                    </nz-form-item>
                    }

                    @if(isAttrAvailable('comment')){
                    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item  nz-padding-left">
                        <nz-row>
                            <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="comment"
                                class="ppl-form-label">{{getAttributes('comment').label}}
                                @if(getAttributes('comment').mandatory === 'Y'){
                                <span>*</span>
                                }
                            </nz-form-label>
                            <nz-form-control class="ppl-form-control" nz-tooltip
                                nzTooltipTitle="{{getAttributes('comment').tooltip}}" nzTooltipPlacement="topRight">
                                <textarea rows="4" cols="40" nz-input formControlName="comment" id="comment"
                                    class="ppl-form-control" placeholder="{{getAttributes('comment').placeholder}}"
                                    [ngClass]="{'error': validationErrors['comment'] }"></textarea>
                                @if (validationErrors['comment']) {
                                <span class="pl-1 error-message">{{validationErrors['comment']}}</span>
                                }
                            </nz-form-control>

                        </nz-row>

                    </nz-form-item>
                    }
                </form>
            </div>
        </div>
        }

        @if(showStatusAddErrorMessage) {
        <div class="w-100 alert alert-danger custom-message">{{customErrorMessage}}</div>
        }

        @if(prvdrAssociationsStatus && prvdrAssociationsStatus.length > 0) {
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isAssociationsEditable"
            [data]="prvdrAssociationsStatus" [disableSelection]="true" [cols]="statusCols" [gridTitle]="false"
            [pagination]="true" [loadPage]="false" [actionButtons]="actionButtons"
            (gridAction)="action($event)"></ppl-list-table>
        }
        @else {
        <nz-alert nzType="info" nzMessage="No data available for you." nzShowIcon></nz-alert>
        }
    </ng-template>
</div>
}